<template>
  <div class="afdc-alert afdc-alert-warning" v-if="fuels && fuels.includes('ELEC') && evNetwork && (evNetwork != 'Non-Networked')">
    <div v-html="$sprintf($t('Data for this station comes from the %s network. You can use this form to suggest updates, but we also recommend that you <a href=\'%s\'>contact the network</a> directly to report changes because we cannot edit station information for this network.'), evNetworkCode(evNetwork), evNetworkUrl(evNetwork))"></div>
  </div>
</template>

<script>
export default {
  props: ['fuels', 'evNetwork'],
  methods: {
    evNetworkCode(code) {
      return this.$store.getters.loaderElecNetworksByKey[code];
    },

    evNetworkUrl(code) {
      return this.$store.getters.loaderElecNetworkUrlsByKey[code];
    },
  },
};
</script>
